// Page publique ouverte par le client en scannant le QR du comptoir : /c/:commerceId
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { supabase } from './supabase'
import { CORAL, CHARBON, SABLE, Logo, LiensLegaux } from './actions'

const cleStockage = (commerceId) => `jeebi_carte_${commerceId}`

function lireCarte(commerceId) {
  try { return JSON.parse(localStorage.getItem(cleStockage(commerceId))) } catch { return null }
}

export default function Inscription() {
  const { commerceId } = useParams()
  const [commerce, setCommerce] = useState(null)
  const [erreurChargement, setErreurChargement] = useState('')
  const [form, setForm] = useState({ prenom: '', telephone: '', offres: false, site: '' })
  const [envoi, setEnvoi] = useState(false)
  const [erreur, setErreur] = useState('')
  const [carte, setCarte] = useState(() => lireCarte(commerceId))

  useEffect(() => {
    supabase.functions
      .invoke('inscription-client', { body: { action: 'info', commerceId } })
      .then(({ data, error }) => {
        if (error || data?.error) setErreurChargement("Ce lien n'est pas valide. Demande le QR code au comptoir.")
        else setCommerce(data)
      })
  }, [commerceId])

  async function inscrire(e) {
    e.preventDefault()
    setErreur('')
    if (form.prenom.trim().length < 2) { setErreur('Indique ton prénom'); return }
    setEnvoi(true)
    try {
      const { data, error } = await supabase.functions.invoke('inscription-client', {
        body: { action: 'inscrire', commerceId, ...form },
      })
      if (error) {
        const detail = await error.context?.json?.().catch(() => null)
        throw new Error(detail?.error || 'Erreur réseau, réessaie')
      }
      if (data?.error) throw new Error(data.error)
      const nouvelle = { clientId: data.clientId, jeton: data.jeton, googleUrl: data.googleUrl, prenom: form.prenom.trim() }
      try { localStorage.setItem(cleStockage(commerceId), JSON.stringify(nouvelle)) } catch { /* navigation privée */ }
      setCarte(nouvelle)
    } catch (err) {
      setErreur(err.message)
    }
    setEnvoi(false)
  }

  const page = {
    minHeight: '100vh', background: SABLE, fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
    display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '2rem 1rem',
  }
  const bloc = { width: '100%', maxWidth: 400, background: '#fff', borderRadius: 16, padding: '1.5rem', border: '1px solid #e8e0d8' }
  const champ = { width: '100%', padding: '12px 14px', borderRadius: 10, border: '1px solid #e8e0d8', fontSize: 16, boxSizing: 'border-box', marginBottom: 10 }

  if (erreurChargement) {
    return <div style={page}><div style={{ ...bloc, textAlign: 'center', color: '#888' }}>{erreurChargement}</div></div>
  }
  if (!commerce) {
    return <div style={page}><div style={{ color: '#bbb', marginTop: '3rem' }}>Chargement…</div></div>
  }

  return (
    <div style={page}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: '1.5rem' }}>
        <Logo size={36} />
        <div style={{ fontSize: 18, fontWeight: 800, color: CHARBON, letterSpacing: -1 }}>jeebi</div>
      </div>

      <div style={bloc}>
        <div style={{ fontSize: 13, color: '#999', marginBottom: 4 }}>Carte de fidélité</div>
        <div style={{ fontSize: 24, fontWeight: 800, color: CHARBON, marginBottom: 8 }}>{commerce.nom}</div>
        <div style={{ background: '#fff4f0', color: CORAL, borderRadius: 10, padding: '10px 12px', fontSize: 14, fontWeight: 600, marginBottom: '1.25rem' }}>
          🎁 {commerce.objectif} passages = {commerce.recompense}
        </div>

        {carte ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 16, color: CHARBON, marginBottom: 16 }}>
              C'est prêt, {carte.prenom} ! Ajoute ta carte dans ton téléphone :
            </div>
            <a href={carte.googleUrl} style={{
              display: 'block', background: '#000', color: '#fff', borderRadius: 12, padding: '14px',
              fontSize: 16, fontWeight: 700, textDecoration: 'none', marginBottom: 10,
            }}>
              Ajouter à Google Wallet
            </a>
            <div style={{ fontSize: 12, color: '#999', lineHeight: 1.5 }}>
              Sur iPhone : Apple Wallet arrive bientôt. En attendant, montre ton prénom au comptoir,
              tes tampons sont bien enregistrés.
            </div>
            {carte.jeton && <a href={`/p/${carte.jeton}`} style={{ display: 'block', fontSize: 12, color: '#999', marginTop: 14 }}>
              Gérer mes préférences et mes données
            </a>}
          </div>
        ) : (
          <form onSubmit={inscrire}>
            <input style={champ} placeholder="Ton prénom *" autoComplete="given-name"
              value={form.prenom} onChange={e => setForm({ ...form, prenom: e.target.value })} />
            <input style={champ} placeholder="Téléphone (facultatif)" type="tel" autoComplete="tel"
              value={form.telephone} onChange={e => setForm({ ...form, telephone: e.target.value })} />
            {/* Champ piège anti-robots, invisible pour les humains */}
            <input tabIndex={-1} autoComplete="off" aria-hidden="true" value={form.site}
              onChange={e => setForm({ ...form, site: e.target.value })}
              style={{ position: 'absolute', left: -9999, width: 1, height: 1, opacity: 0 }} />

            <label style={{ display: 'flex', gap: 10, alignItems: 'flex-start', fontSize: 13, color: '#666', margin: '6px 0 16px', lineHeight: 1.4 }}>
              <input type="checkbox" checked={form.offres} style={{ marginTop: 2 }}
                onChange={e => setForm({ ...form, offres: e.target.checked })} />
              J'accepte de recevoir les offres de {commerce.nom}. Désinscription possible à tout moment.
            </label>

            {erreur && <div style={{ color: CORAL, fontSize: 13, marginBottom: 10 }}>{erreur}</div>}

            <button type="submit" disabled={envoi} style={{
              width: '100%', background: CORAL, color: '#fff', border: 'none', borderRadius: 12,
              padding: '14px', fontSize: 16, fontWeight: 700, cursor: envoi ? 'wait' : 'pointer',
            }}>
              {envoi ? 'Création…' : 'Créer ma carte'}
            </button>

            <div style={{ fontSize: 11, color: '#aaa', marginTop: 12, lineHeight: 1.5 }}>
              Ton prénom sert uniquement à gérer ta carte de fidélité chez {commerce.nom}.
              Plus d'infos dans la <a href="/legal/confidentialite" style={{ color: '#999' }}>politique de confidentialité</a>.
            </div>
          </form>
        )}
      </div>

      <LiensLegaux style={{ marginTop: '1.5rem' }} />
    </div>
  )
}
